import { useEffect } from "react";
import { AlertTriangle, Check, Info, X } from "react-feather";
import { useToastsDispatch } from "./ToastsContext";
import Typo from "../Typo/Typo";
import Button from "../../commons/Button/Button";

export default function Toast({
  id,
  variant,
  testid,
  heading,
  subheading,
  className,
}) {
  const dispatchToast = useToastsDispatch();

  // Self destruct after 5s if not error variant
  useEffect(() => {
    if (variant !== "error") {
      const timerID = setTimeout(() => {
        dispatchToast({ type: "delete", id });
      }, 5 * 1000);
      return () => clearTimeout(timerID);
    }
  }, [variant, id, dispatchToast]);

  const styles = stylesMap[variant] || stylesMap.info;

  const iconProps = {
    size: 35,
    color: styles.accent,
    strokeWidth: 2,
  };

  const iconsMap = {
    warning: <AlertTriangle {...iconProps} />,
    error: <AlertTriangle {...iconProps} />,
    info: <Info {...iconProps} />,
    success: <Check {...iconProps} />,
  };

  return (
    <div
      data-testid={testid}
      className={["Toast", className].filter(Boolean).join(" ")}
      style={{
        outlineColor: styles.accent,
        borderLeftColor: styles.border,
      }}
    >
      <div className="Toast-icon">{iconsMap[variant] || iconsMap["info"]}</div>
      <div className="Toast-text">
        {heading && <Typo variant={"body3"}>{heading}</Typo>}
        {subheading && <Typo variant={"body4"}>{subheading}</Typo>}
      </div>

      <Button
        className={"Toast-clearButton"}
        icon={<X />}
        onClick={() => dispatchToast({ type: "delete", id })}
      />
    </div>
  );
}

const stylesMap = {
  warning: {
    accent: "var(--color-warning-1)",
    border: "var(--color-warning-2)",
  },
  error: { accent: "var(--color-error-1)", border: "var(--color-error-2)" },
  info: { accent: "var(--color-leano-3)", border: "var(--color-leano-5)" },
  success: {
    accent: "var(--color-success-1)",
    border: "var(--color-success-2)",
  },
};
